<div class="mds-layout">
  <top-bar></top-bar>
  <app-side-menu></app-side-menu>
  <main id="main-content" class="mds-page">
    <router-outlet></router-outlet>
  </main>
</div>

@for (toast of toastMessageList; track toast; let i = $index) {
  @if (toast.type == 'warning') {
    <mc-toast fit="small" appearance="warning" position="top-right" open>
      @if (toast?.message || toast?.htmlMessage) {
        <mc-notification
          icon="exclamation-triangle"
          [heading]="toast?.heading || ''"
          [body]="!toast?.htmlMessage ? toast?.message : undefined"
          [innerHtml]="toast?.htmlMessage || undefined"></mc-notification>
      }
    </mc-toast>
  }

  @if (toast.type == 'success') {
    <mc-toast fit="small" appearance="success" position="top-right" open>
      @if (toast?.message) {
        <mc-notification icon="check-circle" [heading]="toast?.heading || ''" [body]="toast?.message"></mc-notification>
      }
    </mc-toast>
  }

  @if (toast.type == 'error') {
    <mc-toast fit="small" appearance="error" position="top-right" open>
      @if (toast?.message) {
        <mc-notification icon="exclamation-octagon" [heading]="toast?.heading || ''" [body]="toast?.message"></mc-notification>
      }
    </mc-toast>
  }

  @if (toast.type == 'info') {
    <mc-toast fit="small" appearance="info" position="top-right" open>
      @if (toast?.message) {
        <mc-notification icon="info-circle" [heading]="toast?.heading || ''" [body]="toast?.message"></mc-notification>
      }
    </mc-toast>
  }
}
